export const patient = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    id: { en: 'ID', ko: '아이디', fr: '' },
    doctor: { en: 'Doctor', ko: '담당의', fr: '' },
    fullName: { en: 'Name', ko: '이름', fr: '' },
    firstName: { en: 'First Name', ko: '이름', fr: '' },
    lastName: { en: 'Last Name', ko: '성', fr: '' },
    gender: { en: 'Sex', ko: '성별', fr: '' },
    birthDate: { en: 'BirthDate', ko: '생년월일', fr: '' },
    registDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    active: { en: 'Active', ko: '활성', fr: '' },
    recoveryStatus: { en: 'Recovery status', ko: '회복 상태', fr: '' },
    usageTime: { en: 'Usage time', ko: '사용 시간', fr: '' },
    dataAcq: { en: 'Data(yesterday)', ko: '데이터(전일)', fr: '' },
    select: { en: 'Select', ko: '선택', fr: '' },
    level: { en: 'LEVEL', ko: '레벨', fr: '' },
    message: { en: 'MESSAGE', ko: '메세지', fr: '' },
    time: { en: 'TIME', ko: '시간', fr: '' },
  },
  info: {
    id: { en: 'ID', ko: '아이디', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    pat: { en: 'PAT', ko: 'PAT', fr: 'PAT' },
    region: { en: 'Region', ko: '지역', fr: '' },
    city: { en: 'City', ko: '도시', fr: '' },
    firstName: { en: 'First name', ko: '이름', fr: '' },
    lastName: { en: 'Last name', ko: '성', fr: '' },
    gender: { en: 'Sex', ko: '성별', fr: '' },
    birth: { en: 'Birth date', ko: '생년월일', fr: '' },
    zipNum: { en: 'Zip code', ko: '우편번호', fr: '' },
    address: { en: 'Address', ko: '주소', fr: '' },
    time: { en: 'Timezone', ko: '타임존', fr: '' },
    note: { en: 'Note', ko: '비고', fr: '' },
    registDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    activeDeviceList: { en: 'Current device list', ko: '연결된 장치', fr: '' },
    deviceConnection: { en: 'Device connection', ko: '장치 추가', fr: '' },
    patientData: { en: 'Patient device history', ko: '환자 장치 이력', fr: '' },
    device: { en: 'Device', ko: '연결 장비', fr: '' },
    type: { en: 'Type', ko: '타입', fr: '' },
    startDate: { en: 'State date', ko: '시작일시', fr: '' },
    endDate: { en: 'End date', ko: '종료일시', fr: '' },
    patientDetailInfo: { en: 'Patient Detail Info', ko: '환자 상세 정보', fr: '' },
    detailSearch: { en: 'Detailed Search', ko: '상세 검색', fr: '' },
    reset: { en: 'Reset', ko: '초기화', fr: '' },
    search: { en: 'Search', ko: '검색', fr: '' },
    cancel: { en: 'Cancel', ko: '취소', fr: '' },
    ssn: { en: 'Social security num', ko: '주민번호', fr: '' },
    contacts: { en: 'Other Contact Information', ko: '추가 연락처 정보', fr: '' },
    primaryContact: { en: 'Primary Contact', ko: '주요 연락처', fr: '' },
    careManager: { en: 'Care manager', ko: '케어 담당자', fr: '' },
    doctor: { en: 'Doctor', ko: '담당 의사', fr: '' },
    regUser: { en: 'Register user', ko: '등록자 ID', fr: '' },
    message: { en: 'Care Record', ko: '환자 관리 기록', fr: '' },
    lastMessage: { en: 'Last Care Record', ko: '최근 환자 관리 기록', fr: '' },
    phoneNumber: { en: 'Phone number', ko: '전화번호', fr: '' },
    email: { en: 'Email', ko: '이메일', fr: '' },
    age: { en: 'Age', ko: '나이', fr: '' },
    relationship: { en: 'Relationship', ko: '관계', fr: '' },
    addContact: { en: 'Add Contact', ko: '연락처 추가', fr: '' },
    period: { en: 'Period', ko: '기간', fr: '' },
    today: { en: 'Today', ko: '오늘', fr: '' },
    yesterday: { en: 'Yesterday', ko: '어제', fr: '' },
    week: { en: '7D', ko: '일주일', fr: '' },
    month: { en: '1M', ko: '1개월', fr: '' },
    threeMonths: { en: '3M', ko: '3개월', fr: '' },
    accessories: { en: 'Accessories', ko: '악세사리', fr: '' },
    deviceAlarm: { ko: '장비/관리', en: 'Device/Management' },
    patientAlarm: { ko: '환자 상태', en: 'Patient' },
    averageUsage: { ko: '평균 사용 시간', en: 'Average Usage', fr: '' },
    deviceAlarmCount: { ko: '장비/관리 알람 건수', en: 'Device/Management Alarms', fr: '' },
    patientAlarmCount: { ko: '환자 상태 알람 건수', en: 'Patient Alarms', fr: '' },
    countUnit: { ko: '건', en: '', fr: '' },
  },
  csv: {
    last_name: { en: 'Last name', ko: '성', fr: '' },
    first_name: { en: 'First name', ko: '이름', fr: '' },
    gender: { en: 'Register user', ko: '등록자 ID', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    birth_date: { en: 'Birth date', ko: '생년월일', fr: '' },
    id: { en: 'ID', ko: '아이디', fr: '' },
    address: { en: 'Address', ko: '주소', fr: '' },
    zip: { en: 'Zip code', ko: '우편번호', fr: '' },
    ssn: { en: 'Social security num', ko: '주민번호', fr: '' },
    contact: { en: 'Primary Contact', ko: '주요 연락처', fr: '' },
    contact1: { en: 'Contact 1', ko: '연락처 1', fr: '' },
    contact1_relationship: { en: 'Contact 1 Relationship', ko: '연락처 1 관계', fr: '' },
    contact2: { en: 'Contact 2', ko: '연락처 2', fr: '' },
    contact2_relationship: { en: 'Contact 2 Relationship', ko: '연락처 2 관계', fr: '' },
    contact3: { en: 'Contact 3', ko: '연락처 3', fr: '' },
    contact3_relationship: { en: 'Contact 3 Relationship', ko: '연락처 3 관계', fr: '' },
    active: { en: 'Status', ko: '상태' },
  },
  deviceConnection: {
    no: { en: 'No.', ko: '번호', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
    serialNo: { en: 'SerialNo.', ko: '시리얼 번호', fr: '' },
    registDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    connection: { en: 'Connect', ko: '연결', fr: '' },
    available: { en: 'Available', ko: '미사용', fr: '' },
    inUse: { en: 'In Use', ko: '사용중', fr: '' },
  },
  drawer: {
    deviceConnection: { en: 'Device Connection', ko: '장치 추가', fr: '' },
    deviceDisConnection: { en: 'Device DisConnection', ko: '장치 제거', fr: '' },
    startDate: { en: 'Start Date', ko: '시작일시', fr: '' },
    endDate: { en: 'End Date', ko: '종료일시', fr: '' },
    comments: { en: 'Care Record', ko: '환자 관리 기록', fr: '' },
    addComments: { en: 'Add Care Record', ko: '환자 관리 기록 입력', fr: '' },
    typeYourMessageHere: { en: 'Type your care record here', ko: '환자 관리 기록을 입력하세요', fr: '' },
    edited: { en: 'Edited', ko: '수정됨', fr: '' },
    careManager: { en: 'Select care manager', ko: '케어 담당자 선택', fr: '' },
    doctor: { en: 'Select doctor', ko: '담당 의사 선택', fr: '' },
    select: { en: 'Select', ko: '선택', fr: '' },
  },
  remoteSetting: {
    remoteSetting: { en: 'Remote Setting', ko: '원격 설정', fr: '' },
    currentDevice: { en: 'Current Device', ko: '현재 연결된 장치', fr: '' },
    changeSetting: { en: 'Settings Modification', ko: '설정값 변경', fr: '' },
    changeHistory: { en: 'Change History', ko: '변경 이력', fr: '' },
    changeDateTime: { en: 'Changed At', ko: '변경일시', fr: '' },
    settingDetail: { en: 'Configuration Details', ko: '설정 상세', fr: '' },
    resultStatus: { en: 'Result', ko: '결과', fr: '' },
    success: { en: 'Success', ko: '성공', fr: '' },
    fail: { en: 'Failed', ko: '실패', fr: '' },
    change: { en: 'Change', ko: '변경', fr: '' },
    parameter: { en: 'Parameter', ko: '파라미터', fr: '' },
    currentValue: { en: 'Current Value', ko: '현재값', fr: '' },
    infoMessage: {
      en: 'Setting values can only be modified when the therapy mode is HF.',
      ko: '치료 모드가 HF인 경우에만 설정값을 변경할 수 있습니다.',
      fr: '',
    },
    currentTherapyMode: { en: 'Current therapy mode', ko: '현재 치료 모드', fr: '' },
    new: { en: 'New', ko: '변경할', fr: '' },
    value: { en: 'Value', ko: '값', fr: '' },
    valueMust: { en: 'Value must be between', ko: '값의 범위는', fr: '' },
    and: { en: 'and', ko: '~', fr: '' },
    is: { en: '', ko: '입니다.', fr: '' },
    currentSetting: { en: 'Current Setting', ko: '현재 설정값', fr: '' },
    dataQueryTime: { en: 'Queried at', ko: '조회 시각', fr: '' },
    refresh: { en: 'Refresh', ko: '새로고침', fr: '' },
    deviceOffline: {
      en: 'Unable to retrieve settings (device offline)',
      ko: '설정값을 조회할 수 없습니다 (장치 오프라인)',
      fr: '',
    },
  },
  select: {
    organization: { en: 'Organization', ko: '조직', fr: '' },
    manufacturer: { en: 'Manufacturer', ko: '제조사', fr: '' },
    model: { en: 'Model', ko: '모델', fr: '' },
  },
  placeholder: {
    serial: { en: 'Input Serial', ko: '시리얼 번호를 입력하세요.', fr: '' },
    name: { en: 'Search by exact name', ko: '정확한 이름을 입력하세요.', fr: '' },
    hour: { en: 'Hour', ko: '시', fr: '' },
    min: { en: 'min', ko: '분', fr: '' },
  },
  snackbar: {
    deviceDisConnection: { en: 'Are you sure disconnect the device?', ko: '장치를 해제하시겠습니까?', fr: '' },
  },
  errorMessage: {
    hourIsRequired: {
      en: 'Hour is required.',
      ko: '시간을 입력하세요.',
      fr: '',
    },
    hourIsBetween: {
      en: 'Hour can be a number between 0 and 23.',
      ko: '시간을 0 ~ 23 사이의 숫자로 가능합니다.',
      fr: '',
    },
    minutesAreRequired: {
      en: 'Minutes are required.',
      ko: '분은 필수 입력사항입니다.',
      fr: '',
    },
    minutesAreBetween: {
      en: 'Minutes are numbers between 0 and 59.',
      ko: '분은 0에서 59 사이의 숫자입니다.',
      fr: '',
    },
    beforeTheCurrentTime: {
      en: 'Please enter a time before the current time.',
      ko: '현재 시간보다 이전 시간을 입력하세요.',
      fr: '',
    },
    chooseTheTimeAfter: {
      en: 'Please enter the time after admission date',
      ko: '입원일 이후의 시간을 입력하세요.',
      fr: '',
    },
    chooseTheTimeBefore: {
      en: 'Please enter the time before discharge date',
      ko: '퇴원일 이전의 시간을 입력하세요.',
      fr: '',
    },
  },
  message: {
    detailedSearchApplied: { en: 'Detailed search is applied.', ko: '상세 검색이 적용되었습니다.', fr: '' },
    none: { en: 'none', ko: '없음', fr: '' },
    checking: { en: 'checking', ko: '조회중', fr: '' },
    todayPartialData: {
      en: "The 'Setting' chart provides data through today, while other charts provide data through yesterday.",
      ko: "'Setting' 차트는 오늘까지, 그 외 차트는 어제까지의 데이터를 제공합니다.",
      fr: '',
    },
  },
  title: {
    remoteSetting: { en: 'Remote Setting', ko: '리모트 세팅', fr: '' },
  },
  remoteSettingConfirm: {
    confirmRemoteSetting: { en: 'Confirm Remote Setting Value Change', ko: '리모트 설정 값 변경 확인', fr: '' },
    currentValue: { en: 'Current Value', ko: '현재 값', fr: '' },
    newValue: { en: 'New Value', ko: '새 값', fr: '' },
  },
  sdCardDataUpload: {
    en: 'SD Card Data Upload',
    ko: 'SD 카드 데이터 업로드',
    fr: '',
  },
  sdCardDataSelect: {
    en: 'Select SD Card Data',
    ko: 'SD 카드 데이터 선택',
    fr: '',
  },
  selectFolder: {
    en: 'Select Folder',
    ko: '폴더 선택',
    fr: '',
  },
  changeFolder: {
    en: 'Change Folder',
    ko: '폴더 변경',
    fr: '',
  },
  sdCardUploadConfirm: {
    title: { en: 'Do you want to upload SD card data?', ko: 'SD 카드 데이터를 업로드 하시겠습니까?', fr: '' },
    message: {
      en: 'The SD card data of the selected files will be uploaded.',
      ko: '선택된 파일의 SD 카드 데이터를 업로드합니다.',
      fr: '',
    },
    deviceHistoryPeriod: { en: 'Device history period', ko: '환자 장치 이력 기간', fr: '' },
    sdCardPeriod: { en: 'SD card data period', ko: 'SD 카드 데이터 기간', fr: '' },
    uploadPeriod: { en: 'Upload period', ko: '업로드 기간', fr: '' },
    autoGenerateReport: {
      en: "Automatically generate the patient's latest report after upload.",
      ko: '업로드 후 환자의 최신 보고서를 자동으로 생성합니다.',
      fr: '',
    },
    reportGenerationPeriod: { en: 'Report generation period', ko: '보고서 생성 기간', fr: '' },
    upload: { en: 'Upload', ko: '업로드', fr: '' },
    deviceCheckChecking: { en: 'Checking device connection…', ko: '기기 연결 확인 중…', fr: '' },
    deviceCheckError: {
      en: 'Failed to verify device connection. Please try again later.',
      ko: '기기 연결 확인에 실패했습니다. 잠시 후 다시 시도해 주세요.',
      fr: '',
    },
    periodMismatch: {
      en: 'The SD card includes data outside this device’s latest connection period.',
      ko: '이 기기의 최근 연결 기간을 벗어난 데이터가 포함되어 있습니다.',
      fr: '',
    },
    latestMappingPeriod: { en: 'Latest connection period', ko: '최근 연결 기간', fr: '' },
    mappingOngoing: { en: 'Ongoing', ko: '진행 중', fr: '' },
    noMapping: {
      en: 'This device has no connection record with a patient, so it cannot be uploaded.',
      ko: '이 기기는 환자에 연결된 기록이 없어 업로드할 수 없습니다.',
      fr: '',
    },
    deviceNotFound: {
      en: 'Data from a device never connected to this patient cannot be uploaded.',
      ko: '해당 환자에 연결된 적이 없는 기기의 데이터는 업로드 할 수 없습니다.',
      fr: '',
    },
    deviceInactive: {
      en: 'This device is inactive, so it cannot be uploaded.',
      ko: '비활성화된 기기여서 업로드할 수 없습니다.',
      fr: '',
    },
  },
  reportGenerationPeriodOptions: {
    CALENDAR_LAST_MONTH: { en: 'Last 1 month (calendar)', ko: '지난 1개월(달력 기준)', fr: '' },
    CALENDAR_LAST_2_MONTHS: { en: 'Last 2 months (calendar)', ko: '지난 2개월(달력 기준)', fr: '' },
    ROLLING_30_DAYS: { en: 'Last 30 days', ko: '최근 30일', fr: '' },
    ROLLING_2_MONTHS: { en: 'Last 2 months', ko: '최근 2개월', fr: '' },
    ROLLING_3_MONTHS: { en: 'Last 3 months', ko: '최근 3개월', fr: '' },
  },
  sdCardFolder: {
    daysSuffix: { en: ' days', ko: '일', fr: '' },
    filesSuffix: { en: ' files', ko: '개 파일', fr: '' },
    noFiles: {
      en: 'No CSV files were found in the selected folder.',
      ko: '선택한 폴더에서 CSV 파일을 찾을 수 없습니다.',
      fr: '',
    },
    invalidDevice: {
      en: 'Only HFT751 models can be uploaded.',
      ko: 'HFT751 모델만 업로드가 가능합니다.',
      fr: '',
    },
  },
  sdCardUploadHistory: {
    title: { en: 'SD card upload history', ko: 'SD 카드 업로드 이력', fr: '' },
    dataPeriod: { en: 'Data period', ko: '데이터 기간', fr: '' },
    completedAt: { en: 'Uploaded at', ko: '업로드 완료 일시', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    empty: { en: 'No upload history.', ko: '업로드 이력이 없습니다.', fr: '' },
    statusLabel: {
      UPLOADED: { en: 'Uploaded (pending)', ko: '업로드됨(대기)', fr: '' },
      PARSING: { en: 'Processing data', ko: '데이터 처리중', fr: '' },
      AGGREGATING: { en: 'Aggregating', ko: '집계중', fr: '' },
      REPORTING: { en: 'Generating report', ko: '리포트 생성중', fr: '' },
      COMPLETED: { en: 'Completed', ko: '완료', fr: '' },
      'FAILED-PARSING': { en: 'Parse failed', ko: '파싱 실패', fr: '' },
      'FAILED-AGGREGATING': { en: 'Aggregate failed', ko: '집계 실패', fr: '' },
      'FAILED-REPORTING': { en: 'Report failed', ko: '리포트 생성 실패', fr: '' },
    },
  },
  reportHistory: {
    title: { en: 'Auto-generated report history', ko: '리포트 자동 생성 이력', fr: '' },
    /** 업로드 이력 행 아래 하위 행에 붙는 짧은 라벨(별도 섹션 제목 없음). */
    rowLabel: { en: 'Report', ko: '리포트', fr: '' },
    /** 하위 행에서 periodStart~periodEnd를 한 칸에 묶어 보여줄 때의 라벨. */
    period: { en: 'Report period', ko: '리포트 기간', fr: '' },
    periodStart: { en: 'Report start', ko: '리포트 시작 일시', fr: '' },
    periodEnd: { en: 'Report end', ko: '리포트 종료 일시', fr: '' },
    createdAt: { en: 'Generated at', ko: '생성 일시', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    download: { en: 'Download', ko: '다운로드', fr: '' },
    downloadFail: {
      en: 'Failed to get the download link. Please try again.',
      ko: '다운로드 링크를 가져오지 못했습니다. 다시 시도해 주세요.',
      fr: '',
    },
    empty: { en: 'No report history.', ko: '리포트 이력이 없습니다.', fr: '' },
    statusLabel: {
      PENDING: { en: 'Pending', ko: '대기중', fr: '' },
      GENERATING: { en: 'Generating', ko: '생성중', fr: '' },
      COMPLETED: { en: 'Completed', ko: '완료', fr: '' },
      FAILED: { en: 'Failed', ko: '실패', fr: '' },
    },
  },
  sdCardUploadProgress: {
    uploading: { en: 'Uploading…', ko: '업로드 중…', fr: '' },
    uploadingTitle: { en: 'Uploading data', ko: '데이터 업로드 중', fr: '' },
    doNotClose: {
      en: 'Please keep this window open until the upload finishes.',
      ko: '업로드가 끝날 때까지 창을 닫지 마세요.',
      fr: '',
    },
    failedSuffix: { en: ' failed', ko: '건 실패', fr: '' },
    progress: { en: 'Uploaded', ko: '업로드 완료', fr: '' },
    success: {
      en: 'Data upload succeeded.',
      ko: '데이터 업로드에 성공했습니다.',
      fr: '',
    },
    partialFail: {
      en: 'Some files failed to upload. Please retry.',
      ko: '일부 파일 업로드에 실패했습니다. 다시 시도해 주세요.',
      fr: '',
    },
    allFail: {
      en: 'File upload failed. Please try again.',
      ko: '파일 업로드에 실패했습니다. 다시 시도해 주세요.',
      fr: '',
    },
    ingestFail: {
      en: 'Files were uploaded but the processing request failed. Please retry.',
      ko: '파일은 업로드됐으나 처리 요청에 실패했습니다. 다시 시도해 주세요.',
      fr: '',
    },
    noFilesInRange: {
      en: 'There are no files in the selected period.',
      ko: '선택한 기간에 업로드할 파일이 없습니다.',
      fr: '',
    },
    processing: { en: 'Requesting processing…', ko: '데이터 처리 요청 중…', fr: '' },
    retryFailed: { en: 'Retry failed files', ko: '실패 파일 재시도', fr: '' },
    retryIngest: { en: 'Retry data processing', ko: '데이터 처리 요청 재시도', fr: '' },
  },
};
